/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  eqeqeq,
  global-require,
  import/extensions,
  import/no-extraneous-dependencies,
  max-len,
  no-void
*/
import './index.scss';

import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import NavHeader from 'signer/components/common/nav-header';
import HeaderButton from 'signer/components/common/header-button';
import Image from 'common/components/image';
import Link from 'common/components/link';
import FullPageLoader from 'signer/components/common/full-page-loader';
import logger from 'common/logger';
import HfReactHelper from 'common/utils/hf-react-helper';
import createReactClass from 'create-react-class';
import SigDoc from 'hellospa/components/signer-signature-document';

const SignatureRequestConfirm = createReactClass({

  /**
    */

  getInitialState() {
    return {
      isLoading: false,
    };
  },

  /**
     */

  componentDidMount() {
    logger.track('SignatureRequestConfirm.componentDidMount');
  },

  /**
    */

  agree() {

    if (!this.props.signatureRequest.isSigned && !this.state.isLoading) {


      // Reset errors, so we can rerender them if needed
      this.setState({
        isLoading: true,
      });

      const router = this.props.app.router;

      // Finalize signature request
      this.props
        .signatureRequest
        .complete()
        .then((response) => {
          // TODO - this kind of mutation needs to happen within the SignatureRequest model (CC)
          this.props.signatureRequest.isSigned = response.is_valid;
          const postsignPageType = this.props.app.postsignPageType;
          if (postsignPageType) {
            // Redirect to the appropriate postsign page
            window.location = this.getPostsignUrl(postsignPageType);
          } else if (response.is_trusted == false || response.redirect_url == void 0) {
            // Redirect to the confirmation page
            router.redirect('complete', { canWriteBack: response.write_back });
          } else if (
            response.write_back
            && (HfReactHelper.matchesHsDomain(response.redirect_url, '/')
            || HfReactHelper.matchesHsDomain(response.redirect_url, '/home/index'))
          ) {
            window.location = `${response.redirect_url}?writeBackSuccess=true`;
          } else {
            // Redirect to the provided URL
            window.location = response.redirect_url;
          }
        })
        .catch(() => {
          this.setState({
            isLoading: false,
          });
        });

    }
  },

  /**
    */

  getPostsignUrl(type) {
    const cacheKey = encodeURIComponent(this.props.signatureRequest.signer.cacheKey);
    const isEmbedded = this.props.app.isEmbedded() ? '1' : '0';

    return HfReactHelper.urlHelper(
      `postsign/${type}?email_key=${cacheKey}&is_embedded=${isEmbedded}`,
      HfReactHelper.SITE_CODE_HS,
    );
  },

  /**
    */

  render() {

    const isMobile = this.props.app.isMobile;
    let alert;
    let content;
    const infoMessage = (
      <span className='m-signature-request-confirm--info'>
        <div className='m-signature-request-confirm--header-title'>
          <FormattedMessage
            id="signer.confirm.title"
            description="text in signer flow, informing signer the process of signing the document is almost done"
            defaultMessage="Almost done." />
        </div>
        <div data-qa-ref='hellosign-terms-of-service' className='m-signature-request-confirm--header-legal'>
          {}
          { this.props.app.legalVersion == 1
            ? <FormattedHTMLMessage
              id="signer.confirm.legalMessage1"
              description="text in signer flow, informing that signer\'s signature/ID has been inputted in all needed fields"
              defaultMessage="I agree to be legally bound by this document and the <a href='https://www.hellosign.com/terms' class='whitelabel-link' target='_blank' rel='noopener noreferrer'>HelloSign Terms of Service</a>. Click on 'I Agree' to sign this document." />
            : <FormattedHTMLMessage
              id="signer.confirm.legalMessage2"
              description="text in signer flow, informing that signer\'s signature/ID has been inputted in all needed fields"
              defaultMessage="Almost done. By clicking &quot;I Agree&quot; you are legally signing this document and agreeing to the <a href='https://www.hellosign.com/terms' class='whitelabel-link' target='_blank' rel='noopener noreferrer'>eSignature Terms of Service</a>." />
          }
        </div>
      </span>
    );

    const poweredByHelloSignLogo = (
      <Image src={require('common/images/poweredby_HS.png')} className='m-signature-request-confirm--powered-by' />
    );

    const mobileBackButtonContent = (
      <span data-qa-ref='button-back'>
        <i className='ion-ios-arrow-back'></i>
        <FormattedMessage
          id="signer.confirm.backButton.labelText"
          description="button text in signer flow when signature request is complete, when clicked takes back to the previous page"
          defaultMessage="back" />
      </span>
    );

    const desktopBackButtonContent = (
      <span data-qa-ref='button-back' className='m-signature-request-confirm--edit-button'>
        <FormattedMessage
          id="signer.confirm.backButton.desktopText"
          description="button text in signer flow when signature request is complete, when click signer can edit the input fields"
          defaultMessage="Edit" />
      </span>
    );

    const editLink = (
      <Link {...this.props} alias='signNext' field={this.props.signatureRequest.getNextEditableField()}>
        { isMobile ? mobileBackButtonContent : desktopBackButtonContent }
      </Link>
    );

    if (this.state.isLoading) {
      content = (
        <FullPageLoader showDotsLoader={true}>
          <FormattedHTMLMessage
            id="signer.document.loader.finalizing"
            description="text in signer flow informing signer that the document is being finalized as input fields are filled and submitted"
            defaultMessage="We're finalizing your document" />
        </FullPageLoader>
      );
    } else {
      content = (
        <div className='m-signature-request-confirm'>
          <NavHeader className='m-signature-request-confirm--header' {...this.props}>
            { isMobile ? infoMessage : null }
            <div className='m-signature-request-confirm--subheader'>
              { isMobile ? null : infoMessage }
              <div className='m-signature-request-confirm--subheader-nav-right'>
                { editLink }
                <HeaderButton data-qa-ref='button-agree' className='whitelabel-primary-button' onClick={this.agree} {...this.props}>
                  <FormattedMessage
                    id="signer.confirm.agreeButton.labelText"
                    description="button text in signer flow, when clicked signer is legally binded to the document that was signed"
                    defaultMessage="I agree" />
                </HeaderButton>
                <br />
                { this.props.app.customLogoUri && !this.props.app.hasCustomStyles ? poweredByHelloSignLogo : null }
              </div>
              <br />
            </div>
          </NavHeader>

          { alert }
          <SigDoc
            dateFormat={this.props.signatureRequest.settings.dateFormat}
            legacyApp={this.props.app} />

        </div>
      );

    }

    return content;
  },
});

module.exports = SignatureRequestConfirm;
